<template>
    <div class="exhibitor-list">
        <div class="row" v-for="i in Math.ceil(exhibitors.length / 3)">
            <div class="col-sm-6 col-md-4 mb-3" v-for="exhibitor in exhibitors.slice((i - 1) * 3, i * 3)">
                <exhibitor :exhibitor="exhibitor"></exhibitor>
            </div>
        </div>
        <div v-if="!loading && !exhibitors.length" class="alert alert-info">
            {{ __('No favorite exhibitors found') }}
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                exhibitors : [],
                locale : null,
            }
        },
        methods: {
            loadExhibitors() {
                this.loading = true;
                axios.get('/'+ this.locale +'/exhibitors', { params : { favorites : true, per_page : 999 }})
                     .then(response => {
                        this.exhibitors = response.data.pagination.data;
                        this.loading = false;
                     });
            },
            clearExhibitors() {
                axios.post('/favorite-exhibitors/clear');
                this.exhibitors = [];
            }
        },
        mounted() {
            this.locale = window._locale;
            this.loadExhibitors();

            this.eventHub.$on('clearFavoriteExhibitors', () => {
                this.clearExhibitors();
            });
        },
    }
</script>
